<div class="modal-module-wrapper">
  <div class="container padding--none">
    <div class="flex modal-module">
      <div class="modal-module__wrapper">
        <div class="modal-module__content">
          <span
            class="icon icon-close icon--xs"
            (click)="closeModal(CloseType.Skip)"
          ></span>
          <app-carousel-gallery
            [slides]="slides$ | async"
            (navigateModal)="onNavigate($event)"
            (closed)="closeModal($event)"
          >
          </app-carousel-gallery>
        </div>
      </div>
    </div>
  </div>
</div>
